module.exports = __webpack_public_path__ + "img/NotSelected.531668da.png";